import { Button } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ROLES } from '../../../../config/UserRoles';

export default function HistoryBottomNavigation() {
  const me = useSelector((state) => state.me);
  const adminNavBar = () => (
    <div className="lg:hidden fixed bottom-0 bg-white w-full h-18 print-disable">
      <div className="flex w-full justify-between p-2 gap-1">
        <Link
          to="/wms/history"
          className="w-full p-2 bg-gray-50  cursor-pointer text-center"
        >
          <h4 className="text-lg">
            <i className="fas fa-building" />
          </h4>
          <p className="text-sm ">ภาพรวม</p>
        </Link>

        <Link
          to={`/wms/history/table/${me.department_id}`}
          className="p-2 bg-gray-50 w-full cursor-pointer text-center"
        >
          <h4 className="text-lg">
            <i className="fas fa-table" />
          </h4>
          <p className="text-sm">รายการ</p>
        </Link>

        <Link
          to={`/wms/history/department/${me.department_id}`}
          className="p-2 bg-gray-50 w-full cursor-pointer text-center"
        >
          <h4 className="text-lg">
            <i className="fas fa-users" />
          </h4>
          <p className="text-sm">สถิติแผนก</p>
        </Link>

        <Link
          to={`/wms/history/percapita/${me.department_id}`}
          className="p-2 bg-gray-50 w-full cursor-pointer text-center"
        >
          <h4 className="text-lg">
            <i className="fas fa-user" />
          </h4>
          <p className="text-sm">สถิติบุคคล</p>
        </Link>

        <Link
          to="/"
          className="p-2 bg-gray-50 w-full cursor-pointer text-center"
        >
          <h4 className="text-lg">
            <i className="fas fa-cog" />
          </h4>
          <p className="text-sm">จัดการ</p>
        </Link>
      </div>
    </div>
  );

  const superUserNavItem = () => (
    <div className="lg:hidden fixed bottom-0 bg-white w-full h-18 print-disable">
      <div className="flex w-full justify-between p-2 gap-1">
        <Link
          to="/wms/history"
          className="w-full p-2 bg-gray-50  cursor-pointer text-center"
        >
          <h4 className="text-lg">
            <i className="fas fa-building" />
          </h4>
          <p className="text-sm ">ภาพรวม</p>
        </Link>

        <Link
          to={`/wms/history/table/`}
          className="p-2 bg-gray-50 w-full cursor-pointer text-center"
        >
          <h4 className="text-lg">
            <i className="fas fa-table" />
          </h4>
          <p className="text-sm">รายการ</p>
        </Link>

        <Link
          to={`/wms/history/department/`}
          className="p-2 bg-gray-50 w-full cursor-pointer text-center"
        >
          <h4 className="text-lg">
            <i className="fas fa-users" />
          </h4>
          <p className="text-sm">สถิติแผนก</p>
        </Link>

        <Link
          to={`/wms/history/percapita/`}
          className="p-2 bg-gray-50 w-full cursor-pointer text-center"
        >
          <h4 className="text-lg">
            <i className="fas fa-user" />
          </h4>
          <p className="text-sm">สถิติบุคคล</p>
        </Link>

        <Link
          to="/"
          className="p-2 bg-gray-50 w-full cursor-pointer text-center"
        >
          <h4 className="text-lg">
            <i className="fas fa-cog" />
          </h4>
          <p className="text-sm">จัดการ</p>
        </Link>
      </div>
    </div>
  );
  return (
    <div>
      {me.employee_role === ROLES.SUPER_USER
        ? superUserNavItem()
        : adminNavBar()}
    </div>
  );
}
